import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

import softwareDevSolutions from '../../assets/images/software-dev-stacks.png';

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <h1 className="hero-title">
              Building Scalable, Future-Ready Software Solutions
            </h1>
            <p className="hero-subtitle">
              We craft world-class mobile apps, web platforms, APIs & backend systems for businesses that scale.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={scrollToContact}
              className="btn btn-primary hero-cta"
            >
              Let's Build Together
            </motion.button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-visual"
          >
            <img 
              src={softwareDevSolutions}
              alt="Software Development Team" 
              className="hero-image"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 